export default __webpack_public_path__ + "static/media/example-nike-IMG.8f765f31.jpg";